import { createVuexHelpers } from '@thehotelsnetwork/vuex-helpers';

import apiClient from '@/modules/ApiClient';

export const {
  buildApiRequest,
  buildApiTypes,
} = createVuexHelpers(apiClient);
